@if(!data) {
<div><code>Loading ...</code></div>
}
@else {
    @for(type of formTypes; track $index) {
<div class="table-container mat-mdc-card">
  @if(addEnabled){
  <div class="create-form-container">
    <mat-form-field>
      <mat-label id="form-selection-label">{{ 'client.forms.select-form' | translate }}({{type}}):</mat-label>
      <mat-select id="form-selection-value"
                  aria-labelledby="form-selection-label"
                  [(value)]="selectedForm">
        @for (form of filteredAvailableForms(type); track form) {
        <mat-option [value]="form">{{form.displayName}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if(client && selectedForm){
    <a matButton="tonal"
       class="form-selection-button"
       [routerLink]="`/main/form/${selectedForm.formPct}/${selectedForm.formId}/${client.clientId}/null/create`">
      <mat-icon>add_circle</mat-icon>
      {{ 'buttons.add-new' | translate }} {{ 'global.form' | translate }}
    </a>
    }
    @else {
    <button matButton="tonal" class="form-selection-button" disabled>
      <mat-icon>add_circle</mat-icon>
      {{ 'buttons.add-new' | translate }} {{ 'global.form' | translate }}
    </button>
    }
  </div>
  }
  <app-datatable-component [data]="getDataSource(type)" [columns]="getDisplayedColumns(type)" [readOnly]="readOnly"></app-datatable-component>
</div>
    }
}


